export default __webpack_public_path__ + "static/media/DOM-NOV2024.99e82043.png";